import styles from "./Advantages.module.scss";
import MediaQuery from "react-responsive";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import Heading from "../Typography/Heading/Heading";
import AdvantagesCard from "./AdvantagesCard/AdvantagesCard";
import card1Image1 from "../../static/images/card1.png";
import card1Image2 from "../../static/images/card2.png";
import card1Image3 from "../../static/images/card3.png";
import card1Image4 from "../../static/images/card4.png";

export default function Advantages() {
  return (
    <div id="Advantages" className={styles.advantages}>
      <div className={styles.container}>
        <div className={styles.title}>
          <Heading level="h3" fw={500}>
            Преимущества ЭЗС
          </Heading>
        </div>
        <MediaQuery minWidth={1366}>
          <div className={styles.content}>
            <AdvantagesCard
              number="01"
              title="Местоположение"
              description="Максимально удобное расположение в центре города Чебоксары и на федеральной трассе"
              backgroundImg={card1Image1}
            />
            <AdvantagesCard
              number="02"
              title="Время зарядки"
              description="От 30 минут до 1,5 часов до полной зарядки"
              backgroundImg={card1Image2}
            />
            <AdvantagesCard
              number="03"
              title="Стоимость"
              description="18 рублей за кВт⋅ч для всех коннекторов"
              backgroundImg={card1Image3}
            />
            <AdvantagesCard
              number="04"
              title="Удобство оплаты"
              description="Оплата через приложение Electrifly"
              backgroundImg={card1Image4}
            />
          </div>
        </MediaQuery>

        <MediaQuery maxWidth={1365}>
          <div className={styles.content}>
            <Swiper
              className="advantagesSwiper"
              slidesPerView={2}
              spaceBetween={16}
              speed={300}
              breakpoints={{
                375: {
                  slidesPerView: 2,
                },
                575: {
                  slidesPerView: 3,
                },
                775: {
                  slidesPerView: 4,
                },
              }}
              modules={[Navigation, Pagination]}
              pagination={{
                type: "bullets",
                clickable: true,
                el: ".advantages-paginations",
              }}
            >
              <SwiperSlide>
                <AdvantagesCard
                  number="01"
                  title="Местоположение"
                  description="Максимально удобное расположение в центре города Чебоксары"
                  backgroundImg={card1Image1}
                />
              </SwiperSlide>
              <SwiperSlide>
                <AdvantagesCard
                  number="02"
                  title="Время зарядки"
                  description="От 30 минут до 1,5 часов до полной зарядки"
                  backgroundImg={card1Image2}
                />
              </SwiperSlide>
              <SwiperSlide>
                <AdvantagesCard
                  number="03"
                  title="Стоимость"
                  description="18 рублей за кВт⋅ч для всех коннекторов"
                  backgroundImg={card1Image3}
                />
              </SwiperSlide>
              <SwiperSlide>
                <AdvantagesCard
                  number="04"
                  title="Удобство оплаты"
                  description="Оплата через приложение Electrifly"
                  backgroundImg={card1Image4}
                />
              </SwiperSlide>
            </Swiper>
            <div className="advantages-paginations" />
          </div>
        </MediaQuery>
      </div>
    </div>
  );
}
